<template>
    <!-- Remember to also copy the code in the CSS area! -->
    <div v-bind:class="classes.join(' ')" v-bind:style="styles">
        <div class="snowflakes" v-if="(layout != 'mobile-layout' || layout != 'tablet-layout') && show_effect">
            <div ref="snowflake" class="snowflake" v-for="item in snowflake.styleObject" :style="item" v-if="show_effect">
                <img :src="item.img" :width="snowflake.with" :height="snowflake.height" />
            </div>
        </div>
        <component v-bind:is="layout"></component>
    </div>
</template>

<script>
import AppLayout from './layout/AppLayout'
import PaymentLayout from './layout/PaymentLayout'
import AuthLayout from './layout/AuthLayout'
import LoadingLayout from "./layout/LoadingLayout";
import ErrorLayout from "./layout/ErrorLayout";
import BlankLayout from "./layout/BlankLayout";
import EmptyLayout from "./layout/EmptyLayout";
import MobileLayout from './layout/MobileLayout.vue';
import TabletLayout from './layout/TabletLayout.vue';
import LandingPageLayout from './layout/landing-page/LandingPageLayout.vue';

import { getConfigs } from '../utils/utils';

export default {
    name: "Application",
    data() {
        return {
            window: {
                width: 0,
                height: 0
            },
            snowflake: [],
            classes: [],
            styles: {}
        };
    },
    computed: {
        layout() {
            let check = false;
            var layout = 'empty-layout';
            if (this.$route.meta.layout == 'empty-layout' || this.$store.getters.layout == 'empty-layout' || this.$route.meta.layout == 'landing-page-layout' || this.$store.getters.layout == 'landing-page-layout') {
                layout = this.$route.meta.layout || this.$store.getters.layout
            } else {
                (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
                if (check) {
                    layout = 'mobile-layout'
                } else if (this.window.width < 1000) {
                    layout = 'tablet-layout';
                } else {
                    layout = this.$route.meta.layout || this.$store.getters.layout
                }
            }
            return layout;
        },
        show_effect() {
            return this.$store.state.showEffect;
        },
    },
    components: {
        'app-layout': AppLayout,
        'auth-layout': AuthLayout,
        'mobile-layout': MobileLayout,
        'tablet-layout': TabletLayout,
        'landing-page-layout': LandingPageLayout,
        'loading-layout': LoadingLayout,
        'error-layout': ErrorLayout,
        'payment-layout': PaymentLayout,
        'blank-layout': BlankLayout,
        'empty-layout': EmptyLayout,
        // define as many layouts you want for the application
    },
    created() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
    mounted() {
        this.fetch();
    },
    methods: {
        async fetch() {
            this.$store.commit("setLoading", true);
            const configs = await getConfigs();

            if (!Object.keys(configs).length) return;

            this.$store.commit("setConfigs", configs);

            // set theme effect
            const effectID = configs.themes?.effect_id
            const effectApiConfig = configs.themes?.effect_config ? JSON.parse(configs.themes.effect_config) : {}
            this.getEffect(effectID, effectApiConfig);

            // add theme class
            if (configs.themes?.repeated === 'limited') {
                this.classes.push('theme')
            }

            // add theme background
            const raw_bg_url = configs.themes?.login_background_url;
            if (raw_bg_url) {
                const safeUrl = this.normalizeUrl(raw_bg_url);
                this.$set(this.styles, '--background-image', `url("${safeUrl}")`);
            }

            this.$store.commit("setLoading", false);
        },

        normalizeUrl(rawUrl) {
            if (!rawUrl) return '';
            try {
                const encoded = encodeURI(rawUrl);
                return encoded.replace(/#/g, '%23');
            } catch (e) {
                return String(rawUrl).replace(/ /g, '%20');
            }
        },

        getEffect(effectID, effectConfig = {}) {
            if (effectID !== 1) return;
            const effectDefaultConfig = {
                img: ['/themes/newyear2024/theme_effect_hoadao.png', '/themes/newyear2024/theme_effect_hoamai.png'],
                quantity: 50,
                fallingSpeed: 'random',
                shakingSpeed: 4,
                width: 20,
                height: 20,
                opacity: 1
            }
            const effect = {
                ...effectDefaultConfig,
                ...effectConfig
            }
            var styleObject = [];
            for (let i = 0; i < effect.quantity; i++) {
                let item = {
                    img: effect.img[Math.floor(Math.random() * (effect.img.length - 0 + 1) + 0)],
                    position: 'fixed',
                    top: '-10%',
                    left: Math.floor(Math.random() * 101) + '%',
                    'z-index': 9999,
                    'opacity': effect.opacity,
                    '-webkit-user-select': 'none',
                    '-moz-user-select': 'none',
                    '-ms-user-select': 'none',
                    'user-select': 'none',
                    'animation-name': 'snowflakes-fall, snowflakes-shake, snowflakes-fade',
                    '-webkit-animation-name': 'snowflakes-fall, snowflakes-shake, snowflakes-fade',
                    'animation-timing-function': 'linear, ease-in-out, ease-out',
                    '-webkit-animation-timing-function': 'linear, ease-in-out, ease-out',
                    'animation-iteration-count': 'infinite, infinite, infinite',
                    '-webkit-animation-iteration-count': 'infinite, infinite, infinite',
                    'animation-play-state': 'running, running, running',
                    '-webkit-animation-play-state': 'running, running, running',
                    'animation-duration': (effect.fallingSpeed == 'random' ? Math.random() * (10 - 5 + 1) + 5 : effect.fallingSpeed) + 's,' + effect.shakingSpeed + 's,' + (effect.fallingSpeed == 'random' ? Math.random() * (10 - 5 + 1) + 5 : effect.fallingSpeed) + 's',
                    '-webkit-animation-duration': (effect.fallingSpeed == 'random' ? Math.random() * (10 - 5 + 1) + 5 : effect.fallingSpeed) + 's,+' + effect.shakingSpeed + 's,' + (effect.fallingSpeed == 'random' ? Math.random() * (10 - 5 + 1) + 5 : effect.fallingSpeed) + 's',
                    'animation-delay': Math.random() * (10 - 0 + 1) + 0 + 's,' + Math.random() * (5 - 0 + 1) + 0 + 's',
                    '-webkit-animation-delay': Math.random() * (10 - 0 + 1) + 0 + 's,' + Math.random() * (5 - 0 + 1) + 0 + 's',
                }
                styleObject.push(item)
            }
            effect.styleObject = styleObject
            this.snowflake = effect;
            this.$store.commit("setShowEffect", true);
        },

        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        }
    }
}
</script>

<style scoped>
.theme {
    --app-login-text-color: #fff;
    --breadcrumb-text-color: #fff;
    --left-corner-image: url(../../public/themes/newyear2024/login-left.png);
    --right-corner-image: url(../../public/themes/newyear2024/login-right.png);
}
</style>